import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

// Holds all the current experiments running in Blossom. Update and clean this as needed.
export enum Experiment {
  LOB_intent_search_button_text_hotels_pwa = "LOB_intent_search_button_text_hotels_pwa",
  Flex_Blossom_Qualtrics = "Flex_Blossom_Qualtrics",
  HTG_Add_Top_POI_Pins = "HTG_Add_Top_POI_Pins",
  PWA_ESS_Feedback_Loop_Enable = "PWA_ESS_Feedback_Loop_Enable",
  EGTA_BEX_ML_V0 = "EGTA_BEX_ML_V0",
  Typeahead_Enabling_Google_Autocomplete_Suggestion_for_Car_Lob = "Typeahead_Enabling_Google_Autocomplete_Suggestion_for_Car_Lob",
  EG_UIDE_SDK_SF_test = "EG_UIDE_SDK_SF_test",
  Flex_HTG_Blossom_POSa_Redirect_Banner = "Flex_HTG_Blossom_POSa_Redirect_Banner",
  Flex_typeahead_in_wizard = "Flex_typeahead_in_wizard",
  Add_Distance_to_Nearest_Points_on_Hotel_cards = "Add_Distance_to_Nearest_Points_on_Hotel_cards",
  Flex_HFTG_Affinity_Reviews = "Flex_HFTG_Affinity_Reviews",
  Blossom_SRP_Lite_V2 = "Blossom_SRP_Lite_V2",
  MIT_PWASF_PKGFLEXIBILITY_FSSSE = "MIT_PWASF_PKGFLEXIBILITY_FSSSE",
  Blossom_Skip_Server_Fetch = "Blossom_Skip_Server_Fetch",
  Feature_Gate_MAB_on_SF = "Feature_Gate_MAB_on_SF",
  Flex_Blossom_Affinity_Pool_Filters = "Flex_Blossom_Affinity_Pool_Filters",
  LP_SC_Covid19_TravelAdvisory_for_LandingPages = "LP_SC_Covid19_TravelAdvisory_for_LandingPages",
  Chatbot_FAB_for_PWA = "Chatbot_FAB_for_PWA",
  VAC_PhaseOne = "VAC_PhaseOne",
  VAC_PhaseTwo = "VAC_PhaseTwo",
  VAC_PhaseThree = "VAC_PhaseThree",
  New_Package_Flight_Type_Multicity = "MIT_PWA_PKGFLEXIBILITY_MCITYPKG", // 35877
  New_Package_Flight_Type_Oneway = "MIT_PWA_PKGFLEXIBILITY_ONEWAYPKG", // 35880
  Flex_Enable_Graphql_Modules = "Flex_Enable_Graphql_Modules",
  Surface_PWA_SF_Travel_Advisory_Chatbot = "Surface_PWA_SF_Travel_Advisory_Chatbot",
  Package_HC_Different_Pickup_Location = "MIT_PWA_FLEXIBLE_HC", // 37221
  Flex_Blossom_Wizard_Redesign = "Flex_Blossom_Wizard_Redesign", // 37405,
  Blossom_Mab_Wizard_Search_Button_Copy = "Blossom_Mab_Wizard_Search_Button_Copy", // 37516
  Flex_Blossom_Mobile_Wizard_Dates_To_SRP = "Flex_Blossom_Mobile_Wizard_Dates_To_SRP", // 37559
  TNL_for_blossom_launch_for_TVLY = "TNL_for_blossom_launch_for_TVLY", //37891
  TNL_for_blossom_launch_for_Orbitz = "TNL_for_blossom_launch_for_Orbitz", //37890
  Group_Booking_in_CA = "Group_Booking_in_CA", // 37893
  Flex_blossom_landing_page_chatbot = "Flex_blossom_landing_page_chatbot", // 38171
  Alignment_of_Traveler_Input = "Alignment_of_Traveler_Input", // 38265
  posa_switcher_sf_rollout = "posa_switcher_sf_rollout", // 38460
  PWA_Package_Wizard_Multi_LOB = "PWA_Package_Wizard_Multi_LOB", // 38993,
  PWA_banner_VR_scrims_test = "PWA_banner_VR_scrims_test", // 39026
  PWA_Packages_LOB_Added = "PWA_Packages_LOB_Added", // 39173
  PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB = "PWA_PACKAGE_WIZARD_3PP_DEFAULT_TAB", //39172
}

/**
 * Return bucket number of experiment.
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @returns {number} - Experiment Bucket
 */

export const getExperimentBucket = (context: ExtendedContextStore | undefined, experimentName: Experiment): number =>
  context?.experimentContext?.experiments?.[experimentName] || 0;

/**
 * Checks if an experiment is in a given variant.
 * {@link https://tnl.prod.expedia.com}
 * @param {ExtendedContextStore} context - Store where the experiments array live
 * @param {string} experimentName - Experiment name used (check out link)
 * @param {number} value - Defaults to 1. Value that we are checking the experiment against
 * @returns {boolean} - True when the context contains an experiment string that matches a given numeric value
 */
export const isVariantEnabled = (
  context: ExtendedContextStore | undefined,
  experimentName: Experiment,
  value: number = 1
): boolean => getExperimentBucket(context, experimentName) === value;
